import apiClient from "../http/apiClient";
import { SALE_ENDPOINTS } from "../http/endpoints";

const saleDetailUrl = (id) => `${SALE_ENDPOINTS.sales}${id}/`;
const saleItemsUrl = (id) => `${SALE_ENDPOINTS.sales}${id}/items/`;
const saleItemUrl = (id, itemId) => `${SALE_ENDPOINTS.sales}${id}/items/${itemId}/`;
const salePayUrl = (id) => `${SALE_ENDPOINTS.sales}${id}/pay/`;
const saleAuthorizePaymentUrl = (id) => `${SALE_ENDPOINTS.sales}${id}/authorize-payment/`;
const saleReturnUrl = (id) => `${SALE_ENDPOINTS.sales}${id}/return/`;
const saleVoidUrl = (id) => `${SALE_ENDPOINTS.sales}${id}/void/`;
const saleSendToCashUrl = (id) => `${SALE_ENDPOINTS.sales}${id}/send-to-cash/`;
const saleCancelUrl = (id) => `${SALE_ENDPOINTS.sales}${id}/cancel/`;
const saleDeleteUrl = (id) => `${SALE_ENDPOINTS.sales}${id}/`;
const transferAccountsUrl = `${SALE_ENDPOINTS.sales}transfer-accounts/`;
const transferAccountUrl = (id) => `${transferAccountsUrl}${id}/`;
const paymentMethodConfigUrl = `${SALE_ENDPOINTS.sales}payment-method-config/`;
const salesConfigUrl = `${SALE_ENDPOINTS.sales}sales-config/`;

export async function listSales(params = {}) {
  const response = await apiClient.get(SALE_ENDPOINTS.sales, { params });
  return response.data;
}

export async function pendingCount(params = {}) {
  const response = await apiClient.get(SALE_ENDPOINTS.salesPendingCount, { params });
  return response.data;
}

export async function getSale(id, params = {}) {
  const response = await apiClient.get(saleDetailUrl(id), { params });
  return response.data;
}

export async function startSale(payload = {}) {
  const response = await apiClient.post(SALE_ENDPOINTS.salesPosStart, payload);
  return response.data;
}

export async function confirmCart(payload = {}) {
  const response = await apiClient.post(SALE_ENDPOINTS.salesConfirmCart, payload);
  return response.data;
}

export async function addItem(id, payload = {}) {
  const response = await apiClient.post(saleItemsUrl(id), payload);
  return response.data;
}

export async function updateItem(id, itemId, payload = {}) {
  const response = await apiClient.patch(saleItemUrl(id, itemId), payload);
  return response.data;
}

export async function paySale(id, payload = {}) {
  const response = await apiClient.post(salePayUrl(id), payload);
  return response.data;
}

export async function sendToCash(id, payload = {}) {
  const response = await apiClient.post(saleSendToCashUrl(id), payload);
  return response.data;
}

export async function authorizePayment(id, payload = {}) {
  const response = await apiClient.post(saleAuthorizePaymentUrl(id), payload);
  return response.data;
}

export async function voidSale(id, payload = {}) {
  const response = await apiClient.post(saleVoidUrl(id), payload);
  return response.data;
}

export async function returnSale(id, payload = {}) {
  const response = await apiClient.post(saleReturnUrl(id), payload);
  return response.data;
}

export async function cancelSale(id, payload = {}) {
  const response = await apiClient.post(saleCancelUrl(id), payload);
  return response.data;
}

export async function deleteSale(id, branchId, extraParams = {}) {
  const response = await apiClient.delete(saleDeleteUrl(id), {
    params: {
      branch_id: branchId,
      ...extraParams,
    },
  });
  return response.data;
}

export async function releaseReservations(payload = {}) {
  const response = await apiClient.post(SALE_ENDPOINTS.salesReservationRelease, payload);
  return response.data;
}

export async function releaseAllReservations(payload = {}) {
  const response = await apiClient.post(SALE_ENDPOINTS.salesReservationReleaseAll, payload);
  return response.data;
}

export async function cleanupExpiredReservations(payload = {}) {
  const response = await apiClient.post(SALE_ENDPOINTS.salesReservationCleanupExpired, payload);
  return response.data;
}

export async function listTransferAccounts(params = {}) {
  const response = await apiClient.get(transferAccountsUrl, { params });
  return response.data;
}

export async function createTransferAccount(payload = {}) {
  const response = await apiClient.post(transferAccountsUrl, payload);
  return response.data;
}

export async function updateTransferAccount(id, payload = {}) {
  const response = await apiClient.patch(transferAccountUrl(id), payload);
  return response.data;
}

export async function listPaymentMethodConfig(params = {}) {
  const response = await apiClient.get(paymentMethodConfigUrl, { params });
  return response.data;
}

export async function updatePaymentMethodConfig(payload = {}) {
  const response = await apiClient.patch(paymentMethodConfigUrl, payload);
  return response.data;
}

export async function getSalesConfig(params = {}) {
  const response = await apiClient.get(salesConfigUrl, { params });
  return response.data;
}

export async function updateSalesConfig(payload = {}) {
  const response = await apiClient.patch(salesConfigUrl, payload);
  return response.data;
}

// Backward compatibility aliases
export async function createSale(payload = {}) {
  return startSale(payload);
}

export async function updateSale(id, payload = {}) {
  return paySale(id, payload);
}

export const saleService = {
  listSales,
  pendingCount,
  getSale,
  startSale,
  confirmCart,
  addItem,
  updateItem,
  paySale,
  authorizePayment,
  returnSale,
  voidSale,
  sendToCash,
  cancelSale,
  listTransferAccounts,
  createTransferAccount,
  updateTransferAccount,
  listPaymentMethodConfig,
  updatePaymentMethodConfig,
  getSalesConfig,
  updateSalesConfig,
  createSale,
  updateSale,
  deleteSale,
  releaseReservations,
  releaseAllReservations,
  cleanupExpiredReservations,
};

export default saleService;
